import { Injectable } from '@angular/core';
/*
  Generated class for the GlobalProvider provider.
*/
@Injectable()
export class GlobalProvider {

 	 public apiUrl: string = "https://api.picmasters.de/api/admins/";
	  // public apiUrl: string = "http://plentyclip.apps/api/admins/"; 

  public plentySystemURL = ''; // PRODUCTION
  //public plentySystemURL = 'https://tp.plentymarkets-cloud01.com';// DEBUG
  	 
  	public isPlentyPlugin: boolean;

  	public plentyToken: string;

    public has_stream: any;
    public has_crm: any;
    public is_partner: any;
    public is_worker: any;
    
    public action_for_admin_id:any = 1;
  
  constructor() {

  	// Set Plenty Plugin
  	let PlentylangInLocalStorage:string = localStorage.getItem('plentymarkets_lang_');
  	let PlentyTokenInLocalStorage:string = localStorage.getItem('accessToken');

        if(PlentylangInLocalStorage !== null)
        {
        	// console.log('TOKEN FOUND!!!');
            this.isPlentyPlugin = true;
            this.plentyToken = PlentyTokenInLocalStorage;
        }
        else
        {
        	// console.log('TOKEN NOOOOOT FOUND!!!');
            this.isPlentyPlugin = false;
            this.plentyToken = '';
        }

  }


  
}


// WEBPACK FOOTER //
// ./src/providers/global/global.ts